<template>
    <div>
        <navbar-tournoi
            :club="club"
            :tournoi="tournoi"
            :parties="parties"
            :role="role"
            display="resultat"
            @nav="setNav"
            @back="$emit('back')"
            v-if="showMenu"
        />
        
        <div class="g_menuMobile">
            <table class="g_menuFooter">
                <tr>
                    <td colspan="3" class="g_headerFooter">Classement</td>
                </tr>
                <tr>
                    <td>
                        <s-button 
                            theme="is-primary" 
                            icon="users" 
                            label="Inscription" 
                            @onclick="$emit('nav','inscription')"
                            mode="V"
                        />
                    </td>
                    <td>
                        <s-button 
                            theme="is-success" 
                            icon="trophy" 
                            label="Classement" 
                            @onclick="$emit('nav','resultat')"
                            mode="V"
                        /> 
                    </td>
                    <td>
                         <s-button 
                            :theme="enabledSave==null ? 'is-primary is-loading' : 'is-primary'"  
                            icon="save" 
                            label="Sauvegarder" 
                            @onclick="save"
                            mode="V"
                            
                        /> 
                    </td>
                </tr>
            </table>
        </div>
        
        <div class="inscription g_desktopOn">
            <div style="float:right">
                <s-button 
                    theme="is-primary" 
                    icon="users" 
                    label="Inscription des joueurs" 
                    @onclick="$emit('nav','inscription')"
                /> &nbsp;
                <s-button 
                    theme="is-success" 
                    icon="trophy" 
                    label="Classement" 
                    @onclick="$emit('nav','resultat')"
                /> 
            </div>
            <div style="float:left">
                 <s-button 
                    :theme="enabledSave==null ? 'is-primary is-loading' : 'is-primary'" 
                    icon="save" 
                    label="Sauvegarder" 
                    @onclick="save"
                   
                /> 
                &nbsp;<div style="margin-left:10px">
                Nombre de parties : <s-input v-model="tournoi.options.nbParties" theme="is-primary is-small" width="100px"/>
                &nbsp;<s-button label="" @onclick="saveNbPartie" theme="is-success is-small" icon="save"/>
                </div>
            </div>
        </div>
        <div class="array_classement">
        <div class='headerTableClassement' >
            <table class="tableClassement g_desktopOn"  >
                <tr>
                    <th>
                        <s-l id="resultat_array_nomprenom">Nom Prénom</s-l>
                    </th>
                    <th >
                         <s-l id="resultat_array_gagnes">Gagnés</s-l>
                    </th>
                    <th >
                         <s-l id="resultat_array_gagnes">Egalités</s-l>
                    </th>
                    <th >
                         <s-l id="resultat_array_gagnes">Perdus</s-l>
                    </th>
                    <th >
                         <s-l id="resultat_array_goal">Goal Average</s-l>
                    </th>
                    
                </tr>
            </table>   
        </div>
        <div class="listJoueurs">
        <table border="1" class="tableClassement">
            <thead class="tableClassement g_mobileOn">
                <tr>
                <th>
                    Nom du joueur
                </th>
                <th>
                    Parties Gagnées
                </th>
                 <th >
                        <s-l id="resultat_array_gagnes">Egalités</s-l>
                </th>
                <th >
                        <s-l id="resultat_array_gagnes">Perdus</s-l>
                </th>
                <th>
                    Goal Average
                </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(joueur, indexJoueur) in joueurs">
                    
                    <td>
                        {{joueur.nom}} {{joueur.prenom}}
                    </td>
                    <td>
                        <input @change="enabledSave=false" 
                            class="inputClassement" 
                            type="number" style="width:100%" v-model="joueur.gagne"/>
                    </td>
                    <td>
                        <input @change="enabledSave=false" 
                            class="inputClassement" 
                            type="number" style="width:100%" v-model="joueur.egalite"/>
                    </td>
                    <td>
                        {{tournoi.options.nbParties - ((isNaN(joueur.gagne) ? 0 : parseInt(joueur.gagne)) 
                                                        + (isNaN(joueur.egalite) ? 0 : parseInt(joueur.egalite) ) 
                                                      )}}
                    </td>
                    <td>
                        <input @change="enabledSave=false" 
                        class="inputClassement" 
                        type="number" style="width:100%"  v-model="joueur.diff"/>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        </div>
    </div>
</template>
<style scoped>
    .inputClassement {
        border: none;
        font-size: 20px;
    }
    
     .inscription {
        padding-top: 20px;  
        height: 140px;  
        width: 100%; 
        position: fixed;
        z-index: 2;
        top: 40px;
         box-shadow: 0px 9px 7px -5px rgba(0,0,0,0.71);
        -webkit-box-shadow: 0px 9px 7px -5px rgba(0,0,0,0.71);
        -moz-box-shadow: 0px 9px 7px -5px rgba(0,0,0,0.71);
        background-color: var(--backgound-color);
    }
     @media screen and (min-width: 420px) {
        
         .listJoueurs {
                margin-top: 190px;
            }
         .array_classement {
            display: flex;
            height: 100%;
            margin-top: 0px;
        }
        .headerTableClassement {
            position: fixed;
            z-index:3;
            top: 150px;
            width: 100%;
            box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -webkit-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -moz-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            color: white;
        }
        div.divTableClass {
            margin-top: 0px;
            width:100%;
        }
     }
     @media screen and (max-width: 420px) and (min-height: 600px) {
         .array_classement {
            width: 100%;
            margin-top: 10px;
            overflow: auto;
            max-height: 550px;
        }
     }
       @media screen and (max-width: 420px) and (min-height: 700px) {
          .array_classement {
            width: 100%;
            margin-top: 10px;
            overflow: auto;
            max-height: 600px;
        }
      }
     @media screen and (max-width: 420px) {
         
         .listJoueurs {
            margin-top: 50px;
        }
         
        .headerTableClassement {
            position: fixed;
            z-index:3;
            top: 150px;
            width: 100%;
            box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -webkit-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -moz-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            color: white;
        }
        div.divTableClass {
            margin-top: 0px;
            width:100%;
        }
     }
    table.tableClassement {
        table-layout: fixed;
        width:100%;
        color: black;
        font-weight: bolder;
    }
    .tableClassement td,
    th {
        border: 1px solid #000;
        width: 100px;
        text-align: center;
    }
    .tableClassement td:first-child, th:first-child {
            position:sticky;
            left:0;
            z-index:1;
            width: 150px;
            background-color:var(--bluebg);
            color: white;
            text-align: left;
            height: 100%;
    }
    .tableClassement tr th  {
        position:sticky;
        top:0;
        z-index: 2;
        background-color:var(--bluebg);
        color: white;
        text-align:center;
    }
    .tableClassement thead tr th:first-child {z-index:4;background-color:var(--bluebg);}
</style>
<script>
import tournoi_fct from "@/firebase/tournoi"
import firebase_api from "@/firebase/firebase_api"
import navbarTournoi from "@/views/tournoi/navbar.vue"
import PdfResultat from "@/views/tournoi/export/pdfresultat.vue"
import XLSX from 'xlsx'
import VueHtml2pdf from 'vue-html2pdf';
export default {
    props: ["club","tournoi", "role", "menu"],
    components: {
        navbarTournoi
    },
    data() {
        return {
            parties:[],
            joueurs: [],
            enabledSave: true
        }
    },
    mounted() {
        this.joueurs = this.tournoi.joueurs;
        this.joueurs.sort((a,b)=> {
            if (a.nom.trim().toUpperCase() < b.nom.trim().toUpperCase()) return -1;
            return 0;
        });
        
    },
    computed: {
        showMenu: {
            get() {
                if (typeof(this.menu)=="undefined")
                    return true;
                else
                    return false;
            }
            
        }
     },
     methods: {
         setNav() {

         },
         saveNbPartie() {
             this.save();
         },
         save() {
              this.enabledSave = null;
             this.tournoi.classement = [];
             var joueursClassement = JSON.parse(JSON.stringify(this.joueurs));
            
             
             joueursClassement.forEach((joueur, indexJoueur)=>{
                 if (typeof(joueur.gagne)=="undefined" || joueur.gagne=='') {
                     joueur.gagne = 0;
                 }
                 if (typeof(joueur.diff)=="undefined") {
                     joueur.diff = 0;
                 }
                 if (typeof(joueur.egalite)=="undefined" || joueur.egalite=='') {
                     joueur.egalite = 0;
                 }
                 var classementItem= {
                     captain: joueur.nom + " " + joueur.prenom,
                     captainId: joueur.id,
                     coequipier1: "",
                     coequipier2: "",
                     diff: parseInt(joueur.diff),
                     nbPartieJoues: parseInt(this.tournoi.options.nbParties),
                     nbPartieGagne: parseInt(joueur.gagne),
                     nbPartiePerdu: parseInt(this.tournoi.options.nbParties) - (parseInt(joueur.gagne) + parseInt(joueur.egalite)),
                     nbPartieEgalite: parseInt(joueur.egalite),
                     numero: indexJoueur,
                     partieScore: [],
                     score: parseInt(joueur.gagne),
                     parties: []
                 }
                 
                 this.tournoi.classement.push(
                     classementItem
                 )
             })
            this.tournoi.classement.sort((a,b)=> {
                    return b.score - a.score || b.diff - a.diff;
            });
            var classementModif = 1;
            var classementEgalite = true;
            this.tournoi.classement.forEach((classementItem, indexClassement)=>{
                if (!classementEgalite)
                    classementModif = indexClassement+1;
                this.tournoi.classement[indexClassement].classement = classementModif;
                if (indexClassement < this.tournoi.classement.length-1) {
                    var currentItem = this.tournoi.classement[indexClassement];
                    var currentItemNext = this.tournoi.classement[indexClassement+1];
                    
                    if (currentItem.score != currentItemNext.score) {
                        classementModif ++;
                        classementEgalite = false;
                    }
                        
                    else if (currentItem.diff != currentItemNext.diff) {
                        classementModif ++;  
                            classementEgalite = false;    
                    }
                    else
                            classementEgalite = true;
                }
                
            })
             tournoi_fct.object.set(this.club, this.tournoi, ()=>{
                 this.enabledSave = true
             })
         }
     }
}
</script>